import React from 'react';
import { withProps } from 'recompose';
import { RadioInput } from 'components/core/RadioInput';

import './Checkbox.scss';

export const enhance = withProps(({ error }) => ({
	className: 'ss-checkbox',
	type: 'checkbox',
	children: !!error && (
		<div className="error-message">
			{error}
		</div>
	)
}));

export default enhance(RadioInput);
